import {  gql } from '@apollo/client';

export default gql`
    mutation register($email: String!, $password: String!, $firstName: String!, $lastName: String!, $affiliateId: Int, $affiliatlyUserId: Int, $affiliatlyHash: String) {
        Register(input: {email:$email, password:$password, firstName:$firstName, lastName:$lastName, affiliateId:$affiliateId, affiliatlyUserId:$affiliatlyUserId, affiliatlyHash:$affiliatlyHash}) {
            message
        }
    }
`